import { useCallback } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import type { Market } from '@//config/domain-locale-map';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import { useMarket } from '@//providers/MarketSettingsProvider';
import type { LegacyTrackActionAuctionClickEventData } from './legacy-types';
import { mapElasticVehicleToLegacyItem } from './utils';

export const createLegacyTrackAuctionClick = (
  market: Market,
  vehicle: ElasticVehicle,
): LegacyTrackActionAuctionClickEventData => {
  const eventData: LegacyTrackActionAuctionClickEventData = {
    eventType: 'conversion',
    conversionType: 'action-auction-click',
    item: mapElasticVehicleToLegacyItem(market, vehicle),
    pageType: 'product page',
  };

  return eventData;
};

export const useLegacyTrackAuctionClick = () => {
  const market = useMarket();
  const { track } = useLegacyTracking();

  const trackLegacyAuctionClick = useCallback(
    (vehicle: ElasticVehicle) => {
      // Track event with only the event-specific data
      // The provider will inject base data (source, url, eventTimestamp, userData)
      track({
        event: 'conversion',
        data: createLegacyTrackAuctionClick(market, vehicle),
      });
    },
    [market, track],
  );

  return {
    trackLegacyAuctionClick,
  };
};
